import { proxy } from 'valtio';
import { View } from './views';

export type Permission = {
  verboseEditBookings?: boolean;
  canEditLeads?: boolean;
  isAgent?: boolean;
};

export const environment = proxy<{
  VOUCHERS_BASE_URL: string;
  API_URL: string;
  views: View[];
  permissions: Permission[];
  teamId: string;
  teamName: string;
  userRole: string;
  staffId: string;
}>({
  VOUCHERS_BASE_URL: '',
  API_URL: '',
  views: [],
  permissions: [],
  teamId: '',
  teamName: '',
  userRole: '',
  staffId: '',
});
